export default __webpack_public_path__ + "static/media/480_business04-fr-web.72e3d21c.png";